<div class="lp-auth-page dm-grid dm-grid-cols-1 desktop:dm-grid-cols-2" style="min-height: 100dvh">
  <div
    class="dm-flex dm-justify-center dm-relative dm-overflow-hidden dm-padding-horizontal-16 desktop:dm-padding-horizontal-32 dm-padding-vertical-48 desktop:dm-items-center desktop:dm-padding-vertical-0"
  >
    <div class="lp-auth-page__content dm-w-full tablet:dm-max-w-384 dm-relative">
      <dm-background-pattern pattern="grid" size="lg" class="lp-auth-page__pattern" aria-hidden="true" />
      <lp-logo variant="full" class="lp-auth-page__logo dm-block dm-margin-bottom-24" />
      <router-outlet />
    </div>
  </div>

  <div class="dm-none desktop:dm-block dm-padding-right-24 dm-padding-vertical-24">
    <div class="dm-border-radius-20 dm-overflow-hidden dm-w-full dm-h-full">
      <img ngSrc="/assets/images/unsplash-ice.jpg" alt="" class="dm-object-cover dm-w-full dm-h-full" height="1200" width="1600" priority />
    </div>
  </div>
</div>
